import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Twitter = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "twitter",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "m15.0898 21-4.3465-6.4717L5.302 21H3l6.722-7.9927L3 3h5.9102l4.0966 6.0996L18.1395 3h2.302l-6.41 7.6226L21 21h-5.9102Zm2.5635-1.8245h-1.5498L6.2961 4.8245h1.55l3.928 5.7463.6792.9971 5.2 7.6076Z",
      clipRule: "evenodd"
    })
  }));
};
export default Twitter;